import axios, { AxiosResponse } from "axios";
import { aplClient } from "./apiClient";
import { ReduxStateAuth } from "../types/redux/reduxStateAuth";
import { TypeCredForm } from "../types/TypeCredForm";
import { TokenRefreshRequest } from "../types/tokenRefreshRequest";
import { UserSession } from "../types/userSession";

const changePassword = async (
    currentPassword: string,
    newPasswordA: string,
    newPasswordB: string,
    refreshToken: string
): Promise<AxiosResponse<ReduxStateAuth>> => {
    return aplClient().post("auth/changepassword", {
        currentPassword: currentPassword,
        newPasswordA: newPasswordA,
        newPasswordB: newPasswordB,
        refreshToken: refreshToken
    });
};

const getUserConfig = async (loginForm: TypeCredForm): Promise<AxiosResponse<ReduxStateAuth>> => {
    return aplClient().post("auth/getUserConfig", loginForm);
};

const loadUserConfig = async (tokens: TokenRefreshRequest): Promise<AxiosResponse<ReduxStateAuth>> => {
    return aplClient().post("auth/loadUserConfig", tokens);
};

const getRefreshedUserConfig = async (tokenRefreshRequest: TokenRefreshRequest): Promise<AxiosResponse<ReduxStateAuth>> => {
    if (!tokenRefreshRequest.token || !tokenRefreshRequest.refreshToken) {
        return Promise.reject("No token provided");
    }
    const api = axios.create({
        baseURL: "/api",
        headers: {
            "Content-type": "application/json"
        }
    });
    return api.post("auth/refreshUserConfig", tokenRefreshRequest);
};

const logout = async (refreshToken: string): Promise<AxiosResponse<ReduxStateAuth>> => {
    const api = aplClient();
    return api.post("auth/logout", refreshToken);
};

const getUserSessions = async (): Promise<AxiosResponse<UserSession[], any>> => aplClient().get(`auth/usersessions`);

const deleteUserSession = async (sessionId: string): Promise<AxiosResponse<UserSession[], any>> => {
    return aplClient().delete(`auth/usersessions/${sessionId}`);
};

export {

    changePassword,
    getRefreshedUserConfig,
    getUserConfig,
    loadUserConfig,
    logout,
    getUserSessions,
    deleteUserSession
};
